// @generated by tools/docgen — do not edit.
// Source: docs/examples/authorization_meta.md

import React from 'react';
import { AuthorizationMetaDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function AuthorizationMetaPage() {
  return (
    <ExampleLayout title="Authorization Meta" demo={<AuthorizationMetaDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          Uses Meta.action_requires so every action defaults to requiring authorization, while authorize stays anonymous. Same password flow as Authorization, but the rule is expressed once on the channel class.
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-authorization-meta-backend">
        <ExampleSectionHeading id="examples-authorization-meta-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="authorization_meta/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-authorization-meta-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-authorization-meta-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="authorization_meta/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default AuthorizationMetaPage;
